export default __webpack_public_path__ + "static/media/blog-img232.df58e6a4.jpg";